export default {
  SET_LOGGED_IN_USER(state, payload) {
    state.user = payload
  },
  SET_AWAITING_AUTH_CHECK(state, payload) {
    state.awaitingAuthCheck = payload
  }
}
